import memoji1 from "../assets/memoji1.png"; //male
import memoji2 from "../assets/memoji2.png"; //female
import memoji3 from "../assets/memoji3.png";
import memoji4 from "../assets/memoji4.png";
import memoji5 from "../assets/memoji5.png";
import memoji1Chat from "../assets/memoji1-chat.png"; //male
import memoji2Chat from "../assets/memoji2-chat.png"; //female
import memoji3Chat from "../assets/memoji3-chat.png";
import memoji4Chat from "../assets/memoji4-chat.png";
import memoji5Chat from "../assets/memoji5-chat.png";

import {
  Calendar,
  CreditCard,
  User2,
  PhoneIcon,
  Umbrella,
  Bell,
  Plane,
  User,
  Mail,
  Smartphone,
  SpeakerIcon,
  Camera,
  Headphones,
  Watch,
  Sofa,
  Phone,
  Home,
  IdCardIcon,
  BadgeDollarSign,
  ReceiptIcon,
  IdCard,
  CalendarCheckIcon,
  BadgeCheckIcon,
  PhoneCall,
  Tv
} from "lucide-react";

export const getAvatar = (name) => {
  switch (name) {
    case "memoji1":
      return memoji1;
    case "memoji2":
      return memoji2;
    case "memoji3":
      return memoji3;
    case "memoji4":
      return memoji4;
    case "memoji5":
      return memoji5;
    default:
      return null;
  }
};

export const getChatIcon = (name) => {
  switch (name) {
    case "memoji1-chat":
      return memoji1Chat;
    case "memoji2-chat":
      return memoji2Chat;
    case "memoji3-chat":
      return memoji3Chat;
    case "memoji4-chat":
      return memoji4Chat;
    case "memoji5-chat":
      return memoji5Chat;
    default:
      return null;
  }
};

export const getLucideIcon = (name) => {
  switch (name) {
    case "Calendar":
      return Calendar;
    case "CreditCard":
      return CreditCard;
    case "User2":
      return User2;
    case "PhoneIcon":
      return PhoneIcon;
    case "Umbrella":
      return Umbrella;
    case "Bell":
      return Bell;
    case "Plane":
      return Plane;
    case "User":
      return User;
    case "Mail":
      return Mail;
    case "Smartphone":
      return Smartphone;
    case "SpeakerIcon":
      return SpeakerIcon;
    case "Camera":
      return Camera;
    case "Headphones":
      return Headphones;
    case "Watch":
      return Watch;
    case "Sofa":
      return Sofa;
    case "Phone":
      return Phone;
    case "Home":
      return Home;
    case "IdCardIcon":
      return IdCardIcon;
    case "BadgeDollarSign":
      return BadgeDollarSign;
    case "ReceiptIcon":
      return ReceiptIcon;
    case "IdCard":
      return IdCard;
    case "CalendarCheckIcon":
      return CalendarCheckIcon;
    case "BadgeCheckIcon":
      return BadgeCheckIcon;
    case "PhoneCall":
      return PhoneCall;
    case "Tv":
      return Tv;
    default:
      return null;
  }
};
